import { TipoDocumento } from "../models/tipo-documento";

export const TipiDocumento = {
	DSAN_EREDI : "DSAN_EREDI",
	ATTO_COSTITUTIVO : "ATTO_COSTITUTIVO",
	PROCURA : "PROCURA",
	PROVVEDIMENTO_FALLIMENTO : "PROVVEDIMENTO_FALLIMENTO",
	PROVVEDIMENTO_DEL_GIUDICE_TUTELARE : "PROVVEDIMENTO_DEL_GIUDICE_TUTELARE",
	PROVVEDIMENTO_DI_INCASSO_SOMME : "PROVVEDIMENTO_DI_INCASSO_SOMME",
	ALTRO : "ALTRO"
};
